import React from "react";
import map from "lodash/map";
import PreviewNodeWidget from "./PreviewNodeWidget";

export default class PreviewNodeLayerWidget extends React.Component {
    /**
     * Node layer widget for diagram preview
     * @module PreviewNodeLayerWidget
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
    }

    componentDidUpdate(){
        this.props.diagramEngine.nodesRendered = true;
    }

    render() {
        var diagramModel = this.props.diagramEngine.getDiagramModel();
        return (
            <div
                className="node-view"
                style={{
                    transform:
                    "translate(" +
                    diagramModel.getOffsetX() +
                    "px," +
                    diagramModel.getOffsetY() +
                    "px) scale(" +
                    diagramModel.getZoomLevel() / 100.0 +
                    ")",
                    width: "100%",
                    height: "100%"
                }}
            >
                {map(diagramModel.getNodes(), node => {
                    return React.createElement(
                        PreviewNodeWidget,
                        {
                            diagramEngine: this.props.diagramEngine,
                            key: node.id,
                            node: node
                        },
                        this.props.diagramEngine.generateWidgetForNode(node)
                    );
                })}
            </div>
        );
    }
}